<template>
  <div class="index">
    <div :style="`margin: 0 auto; width: ${isMobile() ? '100%' : 'fit-content' };`">
      <div class="support-site" :style="`width: ${isMobile() ? 'calc(50% - 32px)' : '300px' };`">
        <div :style="`padding: 36px 0 36px 0; width: ${isMobile() ? '150px' : '216px' }; margin: 0 auto; height: 114px;`">
          <div style="float: left; height: 114px; font-size: 24px; font-weight: bold;">
            <span style="float: left;">支持站点</span>
            <br>
            <span style="font-size: 14px; color: grey; float: left; line-height: 38px;">Total Sites.</span>
            <br>
            <pre style="width: fit-content;">12138.</pre>
          </div>
        </div>
        <div :style="`padding: 36px 0 36px 0; width: ${isMobile() ? '150px' : '216px' }; margin: 0 auto; height: 114px;`">
          <div style="float: right; height: 114px; font-size: 24px; font-weight: bold;">
            <span style="float: left;">运行时间</span>
            <br>
            <span style="font-size: 14px; color: grey; float: left; line-height: 38px;">Uptime.</span>
            <br>
            <pre style="margin: initial; width: fit-content;">12138.</pre>
          </div>
        </div>
      </div>
      <div :style="`height: 300px; float: left; width: ${isMobile() ? 'calc(50% - 32px)' : '300px' }; margin: 16px; transition: all 0.5s;`">
        <div class="torrent-number" :style="`height: 134px; width: 100%;`">
          <div style="padding: 14px 0 14px 0; width: 112px; margin: 0 auto;">
            <div style="height: 114px; font-size: 24px; font-weight: bold;">
              <span style="float: left;">种子数量</span>
              <br>
              <span style="font-size: 14px; color: grey; float: left; line-height: 38px;">Total Torrent.</span>
              <br>
              <pre style="margin: initial; width: fit-content;">12138.</pre>
            </div>
          </div>
        </div>
        <div class="user-number" :style="`height: 134px; width: 100%;`">
          <div style="padding: 14px 0 14px 0; width: 112px; margin: 0 auto;">
            <div style="height: 114px; font-size: 24px; font-weight: bold;">
              <span style="float: left;">用户数量</span>
              <br>
              <span style="font-size: 14px; color: grey; float: left; line-height: 38px;">Total Torrent.</span>
              <br>
              <pre style="margin: initial; width: fit-content;">12138.</pre>
            </div>
          </div>
        </div>
      </div>
      <div :style="`height: 300px; float: left; width: ${isMobile() ? 'calc(50% - 32px)' : '300px' }; margin: 16px; transition: all 0.5s;`">
        <div class="request-number" :style="`height: 134px; width: 100%;`">
          <div style="padding: 14px 0 14px 0; width: 112px; margin: 0 auto;">
            <div style="height: 114px; font-size: 24px; font-weight: bold;">
              <span style="float: left;">请求次数</span>
              <br>
              <span style="font-size: 14px; color: grey; float: left; line-height: 38px;">Total Request.</span>
              <br>
              <pre style="margin: initial; width: fit-content;">12138.</pre>
            </div>
          </div>
        </div>
        <div class="proxy-number" :style="`height: 134px; width: 100%;`">
          <div style="padding: 14px 0 14px 0; width: 112px; margin: 0 auto;">
            <div style="height: 114px; font-size: 24px; font-weight: bold;">
              <span style="float: left;">代理次数</span>
              <br>
              <span style="font-size: 14px; color: grey; float: left; line-height: 38px;">Total Proxy.</span>
              <br>
              <pre style="margin: initial; width: fit-content;">12138.</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      loading: true,
      registCode: []
    };
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted () {
  }
};
</script>
<style scoped>
.support-site {
  transition: all 0.5s;
  margin: 16px;
  float: left;
  border-radius: 8px;
  height: 300px;
  background: rgba(14, 184, 64, 0.2);
}

.torrent-number {
  border-radius: 8px;
  margin-bottom: 16px;
  background: rgba(255, 199, 115, 0.2);
}

.user-number {
  border-radius: 8px;
  margin-top: 16px;
  background: rgba(48, 223, 243, 0.2);
}

.request-number {
  border-radius: 8px;
  margin-bottom: 16px;
  background: rgba(81, 154, 115, 0.2);
}

.proxy-number {
  border-radius: 8px;
  margin-top: 16px;
  background: rgba(244, 121, 131, 0.2);
}
</style>
